import styled from 'styled-components';

export const AttendeeInfoRoot = styled.div`
  padding: 5% 14.5%;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 6rem 2rem;
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 5rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    grid-template-columns: 2fr 1.5fr;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    grid-template-columns: 1fr 1fr;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    grid-template-columns: 1fr;
  }
`;

export const Image = styled.img`
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Subheadline = styled.p`
  color: ${({ color, theme }) => color || theme.color.black};
  font-size: ${({ theme }) => theme.fontSize.size22};
  margin-bottom: 2rem;

  @media only screen and (max-width: ${({ theme }) =>
    theme.breakpoint.width480}) {
    ${({ theme }) => theme.fontSize.size18};
`;

export const InfoFooterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 4rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    flex-direction: column;
  }
`;

export const SubtitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
  gap: 1.2rem;
  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    flex-direction: column-reverse;
    margin-bottom: 1rem;
  }
`;

export const TitleText = styled.h2<{ color?: string }>`
  color: ${({ theme }) => theme.color.black};
  font-size: ${({ theme }) => theme.fontSize.size40};
  line-height: ${({ theme }) => theme.lineHeight.height130};
  padding-bottom: 1rem;
`;

export const RoleText = styled.p<{ color?: string }>`
  color: ${({ color, theme }) => color || theme.color.black};
  font-size: ${({ theme }) => theme.fontSize.size22};
  line-height: ${({ theme }) => theme.lineHeight.height130};
`;

export const DescriptionText = styled.p`
  font-size: ${({ theme }) => theme.fontSize.size18};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  margin-bottom: 2rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size16};
  }
`;

export const Underline = styled.div<{
  color?: string;
}>`
  width: 160px;
  height: 0.4rem;
  background-color: ${({ color, theme }) => color || theme.color.white};
  margin-top: 1rem;
  margin-bottom: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    margin-top: 0rem;
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  gap: 1.875rem;
`;

export const PortraitCard = styled.div`
  position: relative;
  width: 100%;
  border-radius: 1.2rem;
  overflow: hidden;
  background: #fff;
  border: 4px solid ${({ theme }) => theme.color.lightGrey};
`;

export const PortraitImg = styled.img`
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 3 / 4;
  object-fit: cover;
`;

export const LogoStrip = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: clamp(64px, 18%, 110px); /* responsive */
  background: white;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
`;

export const CompanyLogo = styled.img`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
`;
